import React from 'react';
import ContentBody from './contentBody';
import Footer from './footer';
import Header from './header';

function Home() {
  return (
    <div>
      <Header page="home" />
      <ContentBody page="home" />
      <Footer page="home"/>
    </div>
  );
}

export default Home;
